<template>
  <v-card class="rounded-2" height="100%" :width="cardWidth" elevation="24">
    <!--Card Header-->
    <v-toolbar color="primary" height="88" flat>
      <v-container>
        <v-row>
          <v-col class="d-flex" cols="10">
            <v-tooltip location="right">
              <template v-slot:activator="{ props }">
                <v-toolbar-title
                  class="text-aliceBlue font-weight-bold ml-1 text-h5 mt-2"
                  v-bind="props"
                >
                  <v-icon color="white" class="mt-n2" start size="small">
                    mdi-collage
                  </v-icon>
                  {{ ModelInfo.name }}
                </v-toolbar-title>
              </template>
              <span>{{ ModelInfo.name }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex">
            <v-tooltip location="bottom">
              <template v-slot:activator="{ props }">
                <span
                  class="text-aliceBlue text-caption ml-3 mt-n4 cut-text"
                  v-bind="props"
                >
                  {{ ModelInfo.siteName }}
                </span>
              </template>
              <span>{{ ModelInfo.siteName }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-container>
    </v-toolbar>
    <!--Card Body-->
    <ModelCardItemsList :modelInfo="ModelInfo" class="ml-n2" />
    <!--Card Footer-->
    <v-divider />
    <v-card-actions v-if="userCanUpdate || userCanCreate || userCanDelete">
      <ActionButtonsVue :buttonsList="actionButtons" />
    </v-card-actions>
    <!--Confirm Dialog-->
    <ConfirmDialogDeleteModel
      v-if="showConfirmDialog"
      :dialog="showConfirmDialog"
      :modelInfo="ModelInfo"
      @update:dialog="(value) => (showConfirmDialog = value)"
    />
  </v-card>
</template>

<script>
import ActionButtonsVue from '@/Core.UI.Domain/Components/ActionButtons';
import ModelCardItemsList from '@/Core.Service.Domain/Analytics/Models/Components/ModelCardItemsList';

import ConfirmDialogDeleteModel from '@/Core.Service.Domain/Analytics/Models/Components/ConfirmDialogDeleteModel';

export default {
  name: 'ModelCard',

  components: {
    ActionButtonsVue,
    ModelCardItemsList,
    ConfirmDialogDeleteModel,
  },

  props: {
    ModelInfo: {
      type: Object,
      required: true,
    },
  },

  computed: {
    userCanCreate() {
      return this.$can('create', 'analytics');
    },
    userCanDelete() {
      return this.$can('delete', 'analytics');
    },
    userCanUpdate() {
      return this.$can('update', 'analytics');
    },
  },

  data(instance) {
    return {
      showConfirmDialog: false,
      cardWidth: 360,
      actionButtons: [
        {
          icon: 'pencil',
          toolTip: `Edit ${instance.$route.meta.toolTip}`,
          action: () => {
            // this route will be replaced when the new edit page is ready
            const { id } = instance.ModelInfo;
            instance.$router.push({
              name: 'ModelEdit',
              params: {
                id,
              },
            });
          },
        },
        {
          icon: 'trash-can-outline',
          toolTip: `Delete ${instance.$route.meta.toolTip}`,
          action: () => {
            instance.showConfirmDialog = true;
          },
        },
      ],
    };
  },
};
</script>
